import * as React from 'react';
import Drawer from 'antd/lib/drawer';
import withStyles from 'react-jss';
import Table, { ColumnProps } from 'antd/lib/table';
import { Product } from './Product.interface';
import { ProductColumns } from './Product.Helper';
import { StylesProps } from 'src/Library/Types';
import { commonStyles } from 'src/Library/CommonStyles';

interface IProps extends StylesProps<ReturnType<typeof styles>> {
  products: Product[];
  customer?: string;
  onlyProduct?: boolean;
  supplier?: string;
  shipmentNumber: string;
  showTracking?: boolean;
  handleClose: () => void;
  handleShowTracking: () => void;
}
const ProductDrawer = (props: IProps) => {
  const {
    classes,
    products,
    onlyProduct,
    customer,
    supplier,
    shipmentNumber,
    showTracking,
    handleClose,
    handleShowTracking,
  } = props;

  function getWidth(key: string) {
    switch (key) {
      case 'internalName': return '30%';
      case 'remark': return '45%';
      case 'hsCode':
      default: return '25%';
    }
  }

  const renderTitle = (name: string) => {
    return <span
      className={classes.columnTitle}>
      {name}
    </span>;
  };

  const generateColumns = (): ColumnProps<Product>[] => {
    const columns: ColumnProps<Product>[] = Object.keys(ProductColumns).map((key) => {
      return {
        key,
        dataIndex: key,
        title: renderTitle(ProductColumns[key]),
        width: getWidth(key),
        align: 'left',
        render: (text, record: Product) => {
          switch (key) {
            case 'internalName': return renderProductName(text, record);
            case 'remark':
            case 'hsCode':
            default: return text || '-';
          }
        },
      };
    });
    return columns;
  };

  const renderProductName = (text: string, record: Product) => {
    return `${text} ${record.status === 'ACTIVE' ? '' : '(Inactive)'}`;
  };

  const heading = () => {
    return <span className={classes.header}>Products</span>;
  };

  const renderHeading = () => {
    if (!showTracking) return heading();
    return <div className={classes.flexRow}>
      <div style={{ marginRight: 16 }}>
      <span style={{ fontWeight: 'bold' }}>
        Product Details
      </span> {shipmentNumber}
      </div>
      {!onlyProduct && <a
        onClick={handleShowTracking}
        className={classes.anchor}
        style={{
          fontSize: 14,
        }}
      >
        View Tracking
      </a>}
    </div>;
  };

  const renderCustomer = (key: string, value?: string) => {
    if (!value) return null;
    return <div
      className={classes.customer}>
      {key}: {value}
    </div>;
  };

  return <Drawer
    visible
    closable
    width="50%"
    title={renderHeading()}
    onClose={handleClose}
    className={classes.mainDiv}
  >
    <Table
      pagination={false}
      columns={generateColumns()}
      dataSource={products || []}
    />
    {/* {renderCustomer('Customer', customer)}
    {renderCustomer('Supplier', supplier)} */}
  </Drawer>;
};

const styles = theme => ({
  ...commonStyles(theme),
  mainDiv: {
    '& .ant-drawer-body': {
      padding: 0,
    },
  },
  header: {
    color: '#262626',
    fontSize: 18,
    fontWeight: 'bold',
  },
  columnTitle: {
    fontWeight: 'bold',
  },
  customer: {
    ...commonStyles(theme).flexRow,
    padding: 16,
    fontSize: 16,
    fontWeight: 500,
  },
})

export default withStyles(styles)(ProductDrawer);
